import { c as _c } from "react/compiler-runtime";
import { HelpBots } from 'help-bots';
import { useSyncGrowthbookUserAttributes } from 'growthbook/client';
import Head from 'next/head';
import React, { Suspense, lazy } from 'react';
import Header from 'shared/components/header';
import { useGuard } from 'shared/hooks/use-guard';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRedirectDisabledUser } from 'shared/hooks/use-redirect-disabled-user';
import { useEmailStatusNotification } from 'shared/notifications/hooks/use-email-status-notification';
import { usePaymentNotification } from 'shared/notifications/hooks/use-payment-notification';
import { Snow } from './snow';
import { useChristmas } from './snow/use-christmas';
import { Banner } from 'shared/components/banner';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GrowthbookFlagsEnum } from 'growthbook/types';
const DashboardLayoutAiChat = lazy(() => import('./dashboard-layout-ai-chat'));
interface DashboardLayoutProps extends React.PropsWithChildren {
  browserTabTitle: string;
}
function DashboardLayout(t0) {
  const $ = _c(19);
  const {
    children,
    browserTabTitle
  } = t0;
  useGuard();
  usePaymentNotification();
  useEmailStatusNotification();
  useRedirectDisabledUser();
  useSyncGrowthbookUserAttributes();
  const aiChatFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.AiChat);
  const christmasFeatureIsOn = useChristmas();
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== children) {
    t1 = <main className="py-5 px-4 sm:px-6 md:px-14">{children}</main>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const mainContent = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HelpBots />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== browserTabTitle || $[4] !== t) {
    t3 = t(browserTabTitle);
    $[3] = browserTabTitle;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Head><title>{t3}</title></Head>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Header />;
    t6 = <Banner />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== aiChatFeatureIsOn || $[11] !== mainContent) {
    t7 = <div>{t5}{t6}{aiChatFeatureIsOn ? <Suspense fallback={mainContent}><DashboardLayoutAiChat>{mainContent}</DashboardLayoutAiChat></Suspense> : mainContent}</div>;
    $[10] = aiChatFeatureIsOn;
    $[11] = mainContent;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== christmasFeatureIsOn) {
    t8 = christmasFeatureIsOn && <Snow />;
    $[13] = christmasFeatureIsOn;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t7 || $[17] !== t8) {
    t9 = <>{t2}{t4}{t7}{t8}</>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}
export default DashboardLayout;